<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="12" sm="8">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar Saberes - {{ competencia.competencia }}
            </v-col>

            <v-col cols="12" sm="4">
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Saber"
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn color="primary" @click="open"> Asociar </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="saberesCompetencia"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="editar(item.id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="registrarCupo(item.id)"
                >
                  mdi-text-box-plus
                </v-icon>
              </template>
              <span>Gestionar Cupos</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-dialog persistent max-width="520px" v-model="dialog">
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <v-select
                            outlined
                            dense
                            :disabled="editedIndex === 1"
                            label="Categoría"
                            :items="categorias"
                            :rules="categoriaReglas"
                            item-value="id"
                            item-text="categoria"
                            v-model="categoria"
                            @change="obtenerSaberes"
                          ></v-select>

                          <v-select
                            outlined
                            dense
                            :disabled="editedIndex === 1"
                            label="Saber"
                            :items="saberes"
                            :rules="saberesReglas"
                            item-value="id"
                            item-text="saber"
                            v-model="saber"
                          ></v-select>

                          <v-select
                            outlined
                            dense
                            label="Modalidad"
                            :items="modalidades"
                            :rules="modalidadesReglas"
                            item-value="id"
                            item-text="modalidad"
                            v-model="modalidad"
                          ></v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número Participantes"
                            v-model="numeroParticipantes"
                            :rules="numeroParticipantesReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            readonly
                            type="number"
                            label="Cantidad Grupos"
                            :value="cantidadGrupos"
                            :rules="cantidadGruposReglas"
                          ></v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" text @click="close"> Cancelar </v-btn>
                  <template v-if="editedIndex === -1">
                    <v-btn color="primary" text @click="registrar">
                      Registrar
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="primary" text @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>

      <!-- alerta eliminar -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">
            ¿Está seguro de eliminar este saber?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDelete"> Cancelar </v-btn>
            <v-btn color="primary" text @click="deleteItemConfirm">
              Aceptar
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    headersTable: [
      {
        text: "Saberes",
        value: "saber",
        width: "40%",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Modalidad",
        value: "modalidad",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Número de participantes",
        value: "numero_participantes",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Cantidad de grupos",
        value: "cantidad_grupos",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    dialog: false,
    dialogDelete: false,
    form: false,
    loadingForm: false,
    editedIndex: -1,

    saberId: 0,
    categoria: null,
    modalidad: null,
    numeroParticipantes: null,
    saber: null,
    saberesReglas: [(v) => !!v || "Selecciona un saber"],

    categoriaReglas: [(v) => !!v || "Selecciona una categoría"],
    modalidadesReglas: [(v) => !!v || "Selecciona una modalidad"],
    numeroParticipantesReglas: [
      (v) => !!v || "Escriba un número de participantes",
      (v) => !v || v > 0 || "El número debe ser mayor a 0",
    ],

    cantidadGruposReglas: [
      (v) => !v == 0 || "El número de participantes debe ser par",
    ],
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch(
      "obtenerCompetenciaCampesenaId",
      this.$route.params.idCompetencia
    );
    this.$store.dispatch(
      "gestionarSaberesCompetencia",
      this.$route.params.idCompetencia
    );
    this.$store.dispatch("gestionarCategoriasCampesena");

    this.$store.dispatch("crearModalidades");

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Asociar Saber"
        : "Actualizar Saber";
    },

    saberes() {
      return this.$store.getters.obtenerSaberes;
    },

    saberesCompetencia() {
      return this.$store.getters.obtenerSaberesCompetencia;
    },

    saberCompetencia() {
      return this.$store.getters.obtenerSaberCompetencia;
    },

    competencia() {
      return this.$store.getters.obtenerCompetenciaCampesena;
    },

    categorias() {
      return this.$store.getters.obtenerCategoriasCampesena;
    },

    modalidades() {
      return this.$store.getters.obtenerModalidades.filter(
        (modalidad) => modalidad.id <= 2
      );
    },

    cantidadGrupos() {
      if (this.modalidad == 2) {
        if (this.numeroParticipantes % 2 == 0) {
          return this.numeroParticipantes / this.modalidad;
        }
        return 0;
      }

      return this.numeroParticipantes;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    open() {
      this.dialog = true;
    },
    obtenerSaberes() {
      this.$store.dispatch("gestionarSaberesCampesena", this.categoria);
    },

    close() {
      this.dialog = false;
      this.editedIndex = -1;
      this.$refs.form.reset();
    },

    registrar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;
        const saberCompetencia = {
          saber_id: this.saber,
          modalidad_id: this.modalidad,
          numero_participantes: this.numeroParticipantes,
          cantidad_grupos: this.cantidadGrupos,
        };

        this.$store
          .dispatch("registrarSaberCompetencia", {
            idCompetencia: this.$route.params.idCompetencia,
            saber: saberCompetencia,
          })
          .then((response) => {
            if (response.status == "success") {
              this.loadingForm = false;
              this.close();

              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch(
                "gestionarSaberesCompetencia",
                this.$route.params.idCompetencia
              );
              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },

    editar(idSaber) {
      this.editedIndex = 1;
      this.saberId = idSaber;
      this.competenciaSeleccionada = this.competencia.competencia;

      this.$store.dispatch("obtenerSaberCompetenciaId", {
        idCompetencia: this.$route.params.idCompetencia,
        idSaber: idSaber,
      });
      setTimeout(() => {
        const detalles = this.saberCompetencia;
        this.categoria = detalles.categoria_id;
        this.saber = detalles.saber_id;
        this.modalidad = detalles.modalidad_id;
        this.numeroParticipantes = detalles.numero_participantes;

        this.obtenerSaberes();
      }, 2000);

      this.dialog = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;
        const saberCompetencia = {
          modalidad_id: this.modalidad,
          numero_participantes: this.numeroParticipantes,
          cantidad_grupos: this.cantidadGrupos,
        };

       

        this.$store
          .dispatch("actualizarSaberCompetencia", {
            idCompetencia: this.$route.params.idCompetencia,
            idSaber: this.saberId,
            saber: saberCompetencia,
          })
          .then((response) => {
            if (response.status == "success") {
              this.close();
              this.loadingForm = false;

              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch(
                "gestionarSaberesCompetencia",
                this.$route.params.idCompetencia
              );
              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },
    eliminar(item) {
      this.$store
        .dispatch("eliminarSaberCompetencia", {
          idCompetencia: this.$route.params.idCompetencia,
          idSaber: item,
        })
        .then((response) => {
          if (response.status == "success") {
            let message = response.message.split(",");
            this.alertType = "success--text";
            this.alertTitle = message[0];
            this.alertMessage = message[1];
            this.alert = true;

            this.$store.dispatch(
              "gestionarSaberesCompetencia",
              this.$route.params.idCompetencia
            );

            this.skeletonLoader = true;

            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 2000);
          } else {
            this.loadingForm = false;
            this.alertType = "error--text";
            this.alertTitle = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0];
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
          this.dialogDelete = false;
        })
        .catch(() => {});
    },

    deleteItem(item) {
      this.saberId = item;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.eliminar(this.saberId);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    registrarCupo(item) {
      this.$router.push({
        name: "campesena-cupo-gestionar",
        params: {
          idCompetencia: this.$route.params.idCompetencia,
          idSaber: item,
        },
      });
    },
    regresar() {
      this.$router.back();
    },
  },
};
</script>
